const Footer = () => {
  return (
    <footer className="footer section">
      <div className="footer__bg-text">Ahad Ali</div>
      <div className="footer__container container">
        <div className="footer__content">
          <h2 className="footer__headline">
            Your Build Partner for <br />
            Fast-Moving Founders.
          </h2>
          <p className="footer__subtitle">
            From MVP to growth, I design and engineer products with AI
            integrations and automation that reduce manual work and speed up
            execution.
          </p>

          <a
            href="https://cal.com/ahadali/lets-engineer-your-bespoke-product"
            target="_blank"
            rel="noreferrer"
            className="footer__cta"
          >
            Book a Strategy Call <span className="footer__cta-arrow">→</span>
          </a>

          <div className="footer__socials">
            <a
              href="https://wa.me/923241441444"
              target="_blank"
              rel="noreferrer"
              className="footer__social-link"
            >
              WhatsApp
            </a>
            <span className="footer__social-dot">•</span>
            <a
              href="https://linkedin.com/in/ahadalireach"
              target="_blank"
              rel="noreferrer"
              className="footer__social-link"
            >
              LinkedIn
            </a>
            <span className="footer__social-dot">•</span>
            <a
              href="mailto:ahadali.reach@gmail.com"
              target="_blank"
              rel="noreferrer"
              className="footer__social-link"
            >
              Email
            </a>
          </div>

          <p className="footer__copy">
            © {new Date().getFullYear()} Ahad Ali. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
